'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouterRedux = require('react-router-redux');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = (_dec = (0, _reactRedux.connect)(function (state) {
  return { token: state.auth.token };
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    (0, _classCallCheck3.default)(this, App);
    return (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || (0, _getPrototypeOf2.default)(App)).apply(this, arguments));
  }

  (0, _createClass3.default)(App, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.token && nextProps.token) {
        this.props.pushState('/');
      } else if (this.props.token && !nextProps.token) {
        this.props.pushState('/login');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./App.scss');

      return _react2.default.createElement(
        'div',
        { className: styles.app },
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(
          'div',
          { className: styles.appContent },
          this.props.children
        )
      );
    }
  }]);
  return App;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.object.isRequired,
  token: _react.PropTypes.string,
  pushState: _react.PropTypes.func.isRequired
}, _class2.contextTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 1183
// module chunks = 0